<div class="row">
  <div class="col-lg-{{czyBrakObrazka || pokazKomentarz ? 12 : 6}}">
    <label class="c-label c-label--checkbox c-checkbox c-label--inline">
      <input *ngIf="!czyUszkodzenieDomyslnieWybrane" [(ngModel)]="formularzWidoczny" (ngModelChange)="przelaczStanFormularza($event)" type="checkbox" class="c-checkbox u-hidden">
      <span class="c-checkbox__replacement" [ngClass]="elementUszkodzenia.atrybuty ? checkBoxStyle : ''" title="{{checkBoxStyle === 'checked up' ? 'Zwiń' : ''}}"></span>
      <span class="c-label__title text">{{elementUszkodzenia?.opis}}</span>
    </label>
    <shared-formularz *ngIf=!elementUszkodzenia.czyGrupowac
                      [formularzUszkodzenia]="formularzUszkodzenia"
                      [formularzWidoczny]="formularzWidoczny"
                      [rodzajePowierzchni]="elementUszkodzenia.rodzajePowierzchni"
                      [rodzajeMaterialowWykonczenia]="elementUszkodzenia.materialyWykonczenia"
                      [jednostkaPowierzchniUszkodzenia]="elementUszkodzenia.jednostka"
                      [czyPosiadaAtrybuty]="!!elementUszkodzenia.atrybuty"
                      [czyWalidacjaWgPowierzchni]="czyWalidacjaWartosciUszkodzeniaWzgledemWymiarowLokalizacji"
                      [pokazWartosc]="elementUszkodzenia.atrybuty ? elementUszkodzenia.atrybuty.pokazWartosc : false"
                      [pokazWysokosc]="elementUszkodzenia.atrybuty ? elementUszkodzenia.atrybuty.pokazWysokosc : false"
                      [pokazSzerokosc]="elementUszkodzenia.atrybuty ? elementUszkodzenia.atrybuty.pokazSzerokosc : false"
                      [pokazKomentarz]="elementUszkodzenia.atrybuty ? elementUszkodzenia.atrybuty.pokazKomentarz : false"
                      [etykietaWartosci]="elementUszkodzenia.atrybuty ? elementUszkodzenia.atrybuty.etykietaWartosci : ''"
                      [minimalnaWysokosc]="elementUszkodzenia.minimalnaWartoscUszkodzenia || minimalnaWartosc"
                      [maksymalnaWysokosc]="elementUszkodzenia.maksymalnaWartoscUszkodzenia || maksymalnaWartosc"
                      [minimalnaSzerokosc]="elementUszkodzenia.minimalnaWartoscUszkodzenia || minimalnaWartosc"
                      [maksymalnaSzerokosc]="elementUszkodzenia.maksymalnaWartoscUszkodzenia || maksymalnaWartosc"
                      [pokazWyczyscElement]="pokazWyczyscElement"
                      [minimalnaWartoscUszkodzenia]="elementUszkodzenia.minimalnaWartoscUszkodzenia"
                      [maksymalnaWartoscUszkodzenia]="maksymalnaWartoscUszkodzenia"
                      [domyslnaWartoscUszkodzenia]="elementUszkodzenia.domyslnaWartoscUszkodzenia"
                      (wyczyscFormularz)="wyczyscFormularz()"
                      (zmianaFormularza)="aktualizujFormularz($event)">

    </shared-formularz>

    <shared-grupa-uszkodzen *ngIf="elementUszkodzenia.czyGrupowac"
                            [formularzWidoczny]="formularzWidoczny"
                            [formularzUszkodzenia]="formularzUszkodzenia"
                            [elementUszkodzenia]="elementUszkodzenia"
                            [czyUszkodzenieDomyslnieWybrane]="czyUszkodzenieDomyslnieWybrane"
                            [czyWalidacjaWgPowierzchni]="czyWalidacjaWartosciUszkodzeniaWzgledemWymiarowLokalizacji"
                            (wyczyscFormularz)="wyczyscFormularz()"
                            [minimalnyWymiar]="this.minimalnyWymiar"
                            [maksymalnyWymiar]="this.maksymalnyWymiar"
    ></shared-grupa-uszkodzen>

  </div>
</div>
